<div [class.fullscreen]="isFullscreen$ | async" class="new-assets-container">
	<form [formGroup]="assetForm" class="form au-forms">
		<au-cmms-entity-name
			[editMode]="true"
			[disablePreview]="true"
			[autofocusEnabled]="true"
			(controlReady)="addChildControl('name', $event)"
			namePreviewClasses="m-b-sxs"
			[placeholder]="'enter_name' | translate"
		/>

		<div class="m-b-sxs">
			<cmms-locations-section
				[locationsInputList]="assetForm.value?.location"
				(controlReady)="addChildControl('location', $event)"
				[matTooltipText]="'edit_location' | translate"
				[disableMultipleSelect]="true"
				[isRequired]="true"
			/>
		</div>

		<div class="sections">
			<!--TODO Move the component itself into shared folder to make it visual that it's used in multiple places-->
			<image-section
				(addExistingFileClicked)="navigateToExisting($event)"
				[files]="assetForm?.value?.files"
			/>

			@if (featureFlagService.isFFEnabled('aiAssetImageAnalysis')) {
				<au-ai-asset-image-analysis-card
					(analysisCompleted)="onAnalysisCompleted($event)"
					(isLoadingState)="onLoadingStateChanged($event)"
					(filesAdded)="onFilesAdded($event)"
					[attachedFiles]="assetForm?.value?.files"
					[withButton]="true"
				/>
			}
		</div>

		@if (isAiAnalysisLoading()) {
			<au-ai-image-analysis-loading />
		}

		<div class="description m-b-m">
			<cmms-description (controlReady)="addChildControl('description', $event)" />
		</div>

		@if (
			aiAnalysisResponse()?.search_suggestions &&
			aiAnalysisResponse().search_suggestions.length > 0
		) {
			<au-ai-search-suggestions
				[searchSuggestions]="aiAnalysisResponse().search_suggestions"
			/>
		}

		<div class="m-b-m">
			<cmms-labels-section (controlReady)="addChildControl('labels', $event)" />
		</div>

		<div class="m-b-m">
			<maintenance-section
				[expanded]="conditionGradeExpanded()"
				[showSectionIcon]="false"
			>
				<div title-element class="condition d-flex width-100 space-start">
					<asset-condition-grade
						[conditionGrade]="assetForm?.value?.conditionGrade"
						(controlReady)="addChildControl('conditionGrade', $event)"
						(conditionGradeChanged)="conditionGradeChangedHandler($event)"
					/>
				</div>

				<div class="maintenance-content">
					<div class="maintenance-row">
						<div class="condition-grade-note">
							<cmms-simple-textarea
								[label]="'condition_grade_note' | translate"
								(controlReady)="addChildControl('conditionGradeNote', $event)"
							/>
						</div>
					</div>

					<div class="maintenance-row">
						<div class="l-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'DeviationTypeChoices'"
								(controlReady)="addChildControl('deviationType', $event)"
							/>
						</div>

						<div class="m-control">
							<au-cmms-cost
								[labelName]="'cost_of_repair' | translate"
								(controlReady)="addChildControl('costOfRepair', $event)"
							/>
						</div>

						<div class="s-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'CostAllocationChoices'"
								(controlReady)="addChildControl('costAllocation', $event)"
							/>
						</div>
					</div>

					<div class="maintenance-row">
						<div class="l-control">
							<au-maintenance-selector
								[value]="timeframeSignal()"
								[newMode]="true"
								[selectionType]="'TimeframeChoices'"
								(controlReady)="addChildControl('timeframe', $event)"
							/>
						</div>

						<div class="m-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'ConsequenceRatingChoices'"
								(controlReady)="addChildControl('consequenceRating', $event)"
							/>
						</div>

						<div class="s-control">
							<au-maintenance-selector
								[newMode]="true"
								[selectionType]="'RiskLevelChoices'"
								(controlReady)="addChildControl('riskLevel', $event)"
							/>
						</div>
					</div>
				</div>
			</maintenance-section>
		</div>

		<div class="asset-condition-fields">
			<div class="product-name">
				<cmms-simple-input
					[label]="'product_name' | translate"
					(controlReady)="addChildControl('productName', $event)"
				/>
			</div>

			<div class="serial-number">
				<cmms-simple-input
					[label]="'serial_number' | translate"
					(controlReady)="addChildControl('serialNumber', $event)"
				/>
			</div>

			<div class="product-year">
				<cmms-year-selector
					[label]="'product_year' | translate"
					[amountOfYears]="50"
					(controlReady)="addChildControl('productYear', $event)"
				/>
			</div>

			<div class="asset-condition-fields-row">
				<div class="asset-condition-field">
					<cmms-date-picker
						[isInputBased]="true"
						[label]="'installation_date' | translate"
						(controlReady)="addChildControl('installationDate', $event)"
					/>
				</div>

				<div class="asset-condition-field">
					<cmms-cost-input
						[label]="'installation_cost' | translate"
						(controlReady)="addChildControl('installationCost', $event)"
					/>
				</div>
			</div>
		</div>

		<div class="asset-condition-fields-row">
			<div class="warranty">
				<cmms-date-picker
					[isInputBased]="true"
					[label]="'warranty_expired_date' | translate"
					(controlReady)="addChildControl('warranty', $event)"
				/>
			</div>

			@if (enableMatterportIntegration) {
				<div class="asset-condition-field">
					<cmms-simple-input
						[label]="'matterport_share_link' | translate"
						(controlReady)="addChildControl('matterportUrl', $event)"
					/>
				</div>
			}
		</div>

		<div class="m-b-m">
			<cmms-classification
				(classificationsListChanged)="classificationListChanged($event)"
				[attachedClassification]="assetForm?.value?.classifications"
				class="m-b-xs"
			/>
		</div>

		<!--	TODO wait API -->
		<div class="sections">
			<entity-section
				(addExistingEntityItem)="navigateToExisting($event)"
				(addNewEntityItem)="navigateTo($event)"
				(rowSelect)="viewSelected($event)"
				(unlink)="unlinkItem($event.data, 'requests')"
				[entityType]="cmmsPages.editRequest"
				[tableColumns]="tableConfig"
				[tableData]="assetForm?.value?.requests || []"
			/>

			<entity-section
				(addExistingEntityItem)="navigateToExisting($event)"
				(addNewEntityItem)="navigateTo($event)"
				(rowSelect)="viewSelected($event)"
				(unlink)="unlinkItem($event.data, 'incidents')"
				[entityType]="cmmsPages.editIncident"
				[tableColumns]="tableConfig"
				[tableData]="assetForm?.value?.incidents || []"
			/>

			<entity-section
				(addExistingEntityItem)="navigateToExisting($event)"
				(addNewEntityItem)="navigateTo($event)"
				(rowSelect)="viewSelected($event)"
				(unlink)="unlinkItem($event.data, 'workOrders')"
				[entityType]="cmmsPages.editWorkOrder"
				[tableColumns]="tableConfig"
				[tableData]="assetForm?.value?.workOrders || []"
			/>

			<file-section
				(addExistingFileClicked)="navigateToExisting($event)"
				(filesDeleted)="filesDeleted($event)"
				(fullFileLoaded)="fileListChanged($event)"
				[askDeleting]="false"
				[delegateDeleting]="true"
				[fullFileLoadData]="true"
				[loadedFiles]="assetForm?.value?.files"
				[options]="fileLoaderOptions"
				(rowSelect)="viewSelected($event)"
			/>
		</div>
	</form>
</div>
